export enum AutomaticChargeStatusTypesDTO {
  Off = 1,
  Pending = 2,
  Denied = 3,
  Blocked = 4,
  EnabledWithVerification = 5,
  EnabledWithoutVerification = 6,
  Initial = 7,
}
